import React from 'react'
import { linkButtonPrimary } from '../typography/index'
import * as API from '../../service/user'
import GA from '../../shared/tracking/ga'
import { setStage } from '../common/analytics-staging'

import { content } from '../gift-texts/gift-texts'

import Checkbox from '../common/checkbox'

import addCard from '../../utils/addCard'
import GiftContext from '../../context/context'
import ExternalLink from '../common/externalLink'
import { FOUNDERS_MODE, MMC_MODE } from '../../shared/modes'
import { CONTENT_DONE, CONTENT_SIGNUP, CONTENT_LOGIN, CONTENT_ADDCARD } from '../../shared/contentStates'

const RISE_TERMS_URL = 'https://flyxo.com/legal/rise-membership/'
const PRIVACY_POLICY_URL = 'https://docs.flyxo.com/legal/general/privacy-policies.html'
const TERMS_OF_USE_URL = 'https://flyxo.com/legal/terms-of-use/'
const PRIVACY_POLICY_EU_URL = 'https://docs.flyxo.com/legal/general/privacy-policies.html'
const ADD_CARD_BACK_URL = 'https://gift.flyxo.com/activate_rise_finish/'

class RiseContent extends React.Component {
  static contextType = GiftContext
  state = {
    riseAgreement: false,
    privacyPolicy: false,
    isOpenLearnMore: false,
  }

  renderError(field) {
    if (!this.errorText[field] || this.state.errors.includes(field)) {
      return this.errorText[field] || field
    }
    return null
  }

  componentDidMount() {
    setTimeout(() => {
      const { isFinish, isError } = this.props
      if (isFinish && !isError) this.finishActivation()
    }, 100)
  }

  handlerAgree(checkbox, state) {
    GA.send({
      name: `checkbox "${checkbox}" clicked`,
      category: 'forms',
      action: 'agreed',
      label: 'legal',
    })
    this.setState((prevState) => {
      prevState[checkbox] = state
      return { ...prevState }
    })
  }

  getRiseLogin() {
    return content.rise.welcome()
  }

  getFoundersLogin() {
    const { isMmc } = this.props

    return (
      <div>
        { isMmc ? content.mmc.welcome() : content.rise.welcomeFounders() }
        { !isMmc && <>
          {linkButtonPrimary(
            {},
            <button
              key="founders-more-button"
              type="button"
              onClick={() => this.handleLearnMore()}
              className={`${this.state.isOpenLearnMore ? 'isHide' : ''}`}
            >
              Learn More
            </button>
          )}
          <div className={`black-box mb-3 ${this.state.isOpenLearnMore ? '' : 'isHide'}`}>
            {content.rise.extra()}
          </div>
        </> }
      </div>
    )
  }

  handleLearnMore() {
    this.setState({ isOpenLearnMore: true })
  }

  addCard = async () => {
    const cardId = await addCard(ADD_CARD_BACK_URL)
    if (cardId) this.finishActivation()
  }

  getRiseToogles(mode) {
    return (
      <div>
        <h1 className="h1 mb-4 signup">
          Take the private skies once again…with our
          <br />
          <span style={{ color: '#D8353B' }}>Free RISE Experience</span>
          <br />
          via this simple activation
        </h1>
        <div style={{ padding: '0 0 40px' }}>
          <form
            action=""
            autoComplete="off"
          >
            <div className="form-field form-checkbox" style={{ padding: '0 0 20px;' }}>
              <div
                style={{
                  fontSize: '16px',
                  lineHeight: '19px',
                  marginTop: '10px',
                  color: '#393B41',
                }}
              >
                <div style={{ float: 'left', marginRight: '10px' }}>
                  <Checkbox
                    id="riseAgreement"
                    name="riseAgreement"
                    checked={this.state.riseAgreement}
                    onChange={() => this.handlerAgree('riseAgreement', !this.state.riseAgreement)}
                  />
                </div>
                By toggling this button, you are agreeing to{' '}
                <ExternalLink to={RISE_TERMS_URL}>XO Rise Membership Agreement</ExternalLink> and
                you are enrolling in automatic annual payments of $595 beginning at the end of a{' '}
                {mode === FOUNDERS_MODE ? 90 : 60}-day promotional period (“Promotional
                Period”) that will continue until you cancel. You can cancel at any time by sending
                your cancellation request in writing to CancelRISE@flyxo.com. If you cancel prior to
                expiration of the Promotional Period, you will not be charged annual payments.
                Cancellations received after expiration of the Promotional Period are effective at
                the at the end of the annual billing period. There are no refunds or credits for
                partial years.
              </div>
            </div>
            <div
              className="form-field form-checkbox"
              style={{ padding: '0 0 20px', color: '#393B41' }}
            >
              <div style={{ fontSize: '16px', lineHeight: '19px', marginTop: '10px' }}>
                <div style={{ float: 'left', marginRight: '10px' }}>
                  <Checkbox
                    id="privacy"
                    name="privacy"
                    checked={this.state.privacyPolicy}
                    onChange={() => this.handlerAgree('privacyPolicy', !this.state.privacyPolicy)}
                  />
                </div>
                XO will use your data as described in our Privacy Policy, including sharing it with
                the family companies. By toggling the button, you acknowledge that you have reviewed
                and agree to the{' '}
                <ExternalLink to={this.context.formData.isGdpr ? PRIVACY_POLICY_EU_URL : PRIVACY_POLICY_URL}>
                  Privacy Policy
                </ExternalLink>{' '}
                and <ExternalLink to={TERMS_OF_USE_URL}>Terms of Use</ExternalLink> .
              </div>
            </div>
            {linkButtonPrimary(
              {},
              <button
                type="button"
                className={
                  this.state.riseAgreement && this.state.privacyPolicy ? '' : 'button--disabled'
                }
                onClick={this.addCard}
              >
                Add Card
              </button>
            )}
          </form>
        </div>
      </div>
    )
  }

  finishActivation = async () => {
    const {mode, code} = this.context.formData
    this.props.setIsLoading(true)
    GA.send({
      name: `Credit card was added`,
      category: 'forms',
      action: 'added',
      label: 'card',
    })
    setStage(3)
    try {
      const res =
        mode === FOUNDERS_MODE
          ? await API.activatePromocode(code)
          : await API.activateRise()
      if (res.status) this.done()
      else throw new Error()
    } catch (e) {
      this.props.setIsError(true)
      this.props.errorModal(e, 'flyxo')
    } finally {
      this.props.setIsLoading(false)
    }
  }

  done = () => {
    this.props.switchContent(CONTENT_DONE)
    GA.send({
      name: `RISE activated`,
      category: 'forms',
      action: 'activated',
      label: 'promo',
    })
  }

  render() {
    const { contentState, isMmc } = this.props
    const {mode} = this.context.formData

    if (contentState === CONTENT_DONE) {

      return isMmc ? content.mmc.done() : content.rise.done()
    }

    if (contentState === CONTENT_SIGNUP || contentState === CONTENT_LOGIN) {
      if (mode === FOUNDERS_MODE) return this.getFoundersLogin()
      if (mode === MMC_MODE) return this.getFoundersLogin()
      return this.getRiseLogin()
    }

    if (contentState === CONTENT_ADDCARD) return this.getRiseToogles(mode)

    return null
  }
}

export default RiseContent
